import {Grade, GradingSystem, Route} from "../_types";

export const findGradingSystem = (route: Pick<Route, "gradingSystem">, gradingSystems: GradingSystem[]) => {
    return gradingSystems.find(s => s.id == route.gradingSystem)
}

export const getClosestGrade = (route: Pick<Route, "gradingSystem" | "difficulty">, gradingSystems: GradingSystem[]) => {
    const grades = findGradingSystem(route, gradingSystems)?.grades;
    if(!grades) return null;

    let closest: number | null = null;
    let closestGrade: Grade | null = null
    for (let index = 0; index < grades.length; index++) {
        const grade = grades[index];
        if (closest == null) {
            closest = index;
            closestGrade = grade
            continue;
        }
        if (grade.difficulty === route.difficulty) {
            closest = index;
            closestGrade = grade;
            break;
        }
        const distanceToClosest = Math.abs(grade.difficulty - closestGrade!.difficulty);
        const distanceToDifficulty = Math.abs(grade.difficulty - route.difficulty);
        if (distanceToClosest > distanceToDifficulty) {
            closest = index;
            closestGrade = grade;
        }
    }
    return closest == null || closestGrade == null ? null : {
        index: closest,
        grade: closestGrade,
    }
}

export const getGradeDisplay = (route: Route, gradingSystems: GradingSystem[]) => {
    const closest = getClosestGrade(route,gradingSystems);
    return closest?.grade?.label ?? String(route.difficulty);
}